import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { postLoginPath } from "../lib/roles";

export default function ProtectedRoute({ children, requireRole }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-aurora">
        <div className="animate-pulseglow w-10 h-10 rounded-full bg-neonpink" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;

  // Onboarding is only required for end users
  if (user.role === "user" && !user.onboarding_complete && location.pathname !== "/onboarding") {
    return <Navigate to="/onboarding" replace />;
  }

  // If the user lacks the required role, send them to their own home
  if (requireRole && !requireRole.includes(user.role)) {
    return <Navigate to={postLoginPath(user)} replace />;
  }
  return children;
}
